export default __webpack_public_path__ + "static/media/login.ed5e6e19.svg";